import { useEffect, useState } from 'react'
import useGlobalStore from '@/store/useGlobalStore'
import { useCheckDifferentMarket } from '@/lib/hooks/services/useCheckDifferentMarket'

export const useNfrCheck = () => {
  const {
    app: { marketExceptions },
  } = useGlobalStore()
  const { isDifferentMarket, userCountry } = useCheckDifferentMarket()
  const nfrAllowedMarkets = marketExceptions?.nfrAllowedMarkets || []

  const [orderLimit, setOrderLimit] = useState<number | null>(null)
  const [isNfrUser, setIsNfrUser] = useState(false)

  useEffect(() => {
    if (
      Boolean(userCountry) &&
      isDifferentMarket &&
      nfrAllowedMarkets.length > 0
    ) {
      const found = nfrAllowedMarkets.find((m) => m.market === userCountry)
      if (found) {
        setIsNfrUser(true)
        setOrderLimit(found?.orderLimit ?? null)
        return
      }
    }
    setIsNfrUser(false)
    setOrderLimit(null)
  }, [userCountry, isDifferentMarket, nfrAllowedMarkets])

  return { isNfrUser, orderLimit }
}
